var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgScaleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1473_37953)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M38 0H10C4.47715 0 0 4.47715 0 10V38C0 43.5228 4.47715 48 10 48H38C43.5228 48 48 43.5228 48 38V10C48 4.47715 43.5228 0 38 0Z",
    fill: "#EEEDFE"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 10,
    y: 37,
    width: 9,
    height: 8,
    rx: 4,
    transform: "rotate(-90 10 37)",
    fill: "#C2BEF0"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 20,
    y: 37,
    width: 18,
    height: 8,
    rx: 4,
    transform: "rotate(-90 20 37)",
    fill: "#AAA4EA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 30,
    y: 37,
    width: 26,
    height: 8,
    rx: 4,
    transform: "rotate(-90 30 37)",
    fill: "#8F88E2"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1473_37953"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgScaleIcon);
export default __webpack_public_path__ + "static/media/ScaleIcon.0217a6e0b9c8894b09111195bb38007f.svg";
export { ForwardRef as ReactComponent };